import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import itemReducer from "./itemSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    item: itemReducer
});

export default rootReducer;